import { CreateUserRequest, DefaultRoles } from "@api/apiClient";
import { useCreateUser } from "@api/users";
import i18n from "@i18n/i18n";
import { Box, Button, Card, CardContent, Container, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useState } from "react";
import AdminsGrid from "./AdminsGrid";

const AdminsPage = observer(() => {
  const [isUserAdding, setIsUserAdding] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailError, setEmailError] = useState("");
  const createUser = useCreateUser();

  const handleBlur = () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailInput && !regex.test(emailInput)) {
      setEmailError("Invalid email format.");
    } else {
      setEmailError("");
    }
  };

  const handleAdduser = async () => {
    if (!emailInput || emailError) {
      return;
    }

    setIsUserAdding(true); // Set loading state to true

    try {
      const createUserRequest: any = new CreateUserRequest({
        email: emailInput,
        role: DefaultRoles.Admin, // Admin user here but it should be add into config
        //or global location need to discuss with todd where to store
      });
      await createUser.mutateAsync(createUserRequest);

      setEmailInput("");
    } finally {
      setIsUserAdding(false); // Set loading state back to false
    }
  };

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("admin-tab.page.title")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0, width: "100%", position: "relative" }}>
          <Card elevation={3} sx={{ width: "100%", "&.MuiPaper-root": { transition: "none important!" } }}>
            <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "1", width: "100%" }}>
                <Grid container spacing={2}>
                  <Grid size={6}>
                    <TextField
                      fullWidth
                      label={i18n.t("admin-tab.page.email-input-text")}
                      error={!!emailError}
                      helperText={emailError}
                      value={emailInput}
                      onChange={(e) => setEmailInput(e.target.value)}
                      onBlur={handleBlur}
                    />
                  </Grid>
                  <Grid size={1}>
                    <Tooltip title={i18n.t("admin-tab.page.add-button-tooltip")}>
                      <Button loading={isUserAdding} variant="outlined" sx={{ verticalAlign: "center", paddingTop: "10px" }} onClick={handleAdduser}>
                        {i18n.t("admin-tab.page.add-button-text")}
                      </Button>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <AdminsGrid role={DefaultRoles.Admin} />
        </Grid>
      </Grid>
    </Container>
  );
});

export default AdminsPage;
